import { Link } from 'react-router-dom';

// Page 404
function NotFound() {
    return (
        <section className="flex flex-col items-center justify-center text-center py-32 px-8">
            <h1 className="text-6xl font-bold text-blue-400 mb-4">404</h1>
            <p className="text-xl text-gray-400 mb-8">Page non trouvée</p>
            <Link to="/" className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold">Retour à l'accueil</Link>
        </section>
    );
}

export default NotFound;